import React, { useCallback } from 'react';
import type { ReactNode, KeyboardEvent, MouseEvent, AriaRole } from 'react';

type InteractiveElementProps = {
	tagName?: keyof HTMLElementTagNameMap;
	role?: AriaRole;
	onClick?: (event?: MouseEvent) => void;
	children?: ReactNode;
} & React.HTMLAttributes<HTMLElement>;

export const InteractiveElement: React.FC<InteractiveElementProps> = ({
	onClick,
	children,
	role = 'button',
	tagName: TagName = 'div',
	...props
}) => {
	const handleKeyDown = useCallback(
		(event: KeyboardEvent) => {
			// Runs onClick on space and enter key press for accessibility
			if (event.key === ' ' || event.key === 'Enter') {
				event.preventDefault();
				onClick && onClick();
			}
		},
		[onClick],
	);

	return (
		<TagName tabIndex={0} role={role} onClick={onClick} onKeyDown={handleKeyDown} {...props}>
			{children}
		</TagName>
	);
};

export default InteractiveElement;
